<template>
	<v-app class="guest-page">
		<div id="auth" class="fill-height">
			<v-layout wrap fill-height justify-center align-content-center>
				<div class="d-block">
					<slot />
				</div>
			</v-layout>
		</div>
	</v-app>
</template>
<script>

export default {
	props: {
		//
	},
	data () {
		return {
			//
		}
	}
}
</script>
